import React, { useEffect, useState } from 'react';

import RichTextEditor from 'components/RichTextEditor';
import { StyledGrid } from 'styles/common';

export const MAX_CHARACTERS = 5000;
export const ERROR_MESSAGE = 'Comment size should be less than 5000 characters';

const ControlledTextField = ({
  placeholder = '',
  defaultText,
  plainDefaulText,
  onSubmit,
  loading,
  disabled,
  isRequired,
}) => {
  const [text, setText] = useState(defaultText);
  const [plainText, setPlainText] = useState(plainDefaulText);

  const handleRTESubmit = (htmlText, plainText_) => {
    onSubmit(htmlText, plainText_);
  };

  const showError = isRequired && !plainText;

  useEffect(() => {
    setText(defaultText);
    setPlainText(plainDefaulText);
  }, [defaultText, plainDefaulText]);

  useEffect(() => {
    if (loading) {
      setText(defaultText);
      setPlainText(plainDefaulText);
    }
  }, [loading]);

  return (
    <StyledGrid container direction="column" alignItems="flex-end">
      <RichTextEditor
        placeholder={placeholder}
        initialText={text}
        plainText={plainText}
        disabled={disabled}
        maxCharLimit={MAX_CHARACTERS}
        onBlur={handleRTESubmit}
        loading={loading}
        showError={showError}
      />
    </StyledGrid>
  );
};

export default ControlledTextField;
